<!-- <ul class="nav navbar-nav left-nav collapse"> -->
  <!-- <li style="padding:0 5px;" (click)="decfont()">
      <a id="fontMinus" href="javascript:void(0)">-A</a>
  </li>
  <li style="padding:0 5px;" (click)="resetSize()">
    <a id="fontNormal" class="active" href="javascript:void(0)">A</a>
</li>
  <li style="padding:0 5px;" id="incfont" (click)="incfont()">
      <a id ="fontPlus" href="javascript:void(0)">+A</a>
  </li>                                                                                                    -->
<!-- </ul> -->

<li style="border-left: none;" (click)="decfont()" >
        <a id="fontMinus" class="fontBox-a" href="javascript:void(0)" title="{{bs.getResource('rbkey_DcrsFntSz')}}" >-A</a>
    </li>
    <li style="border-left: none;" (click)="resetSize()">
        <a id="fontNormal" class="fontBox-a active"  href="javascript:void(0)"  title="{{bs.getResource('rbkey_RstFontSz')}}"  >A</a>
    </li>
    <li style="border-left: none;" id="incfont" (click)="incfont()">
        <a id="fontPlus" class="fontBox-a" href="javascript:void(0)" title="{{bs.getResource('rbkey_IcrsFontSz')}}" >+A</a>
    </li>